import {EventEmitter, Injectable } from '@angular/core';
import {Observable, tap} from "rxjs";
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {JwtData} from "../types/jwt-data";
import jwt_decode from "jwt-decode";
import {FormService} from "./form.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private token: string | null = null;
  public authnRequest: string | null = null;
  loginChanged = new EventEmitter<boolean>();

  constructor(private http: HttpClient,
              private formService: FormService) {
    if (!this.token) {
      // try to load from session storage
      this.token = sessionStorage.getItem("token");
    }
  }

  login(samlArt?: string) : Observable<any> {
    return this.http.get("api/auth/saml",
      { params: samlArt ? {'SAMLart': samlArt} : undefined,
        headers: {"Accept": "*/*", "Content-Type": "application/x-www-form-urlencoded"},
        observe: 'response',
        responseType: 'text'}
    )
      .pipe(
        tap(
          {
            next: (response) => {
              if (samlArt) {
                this.token = response.body;
                if (this.token) {
                  sessionStorage.setItem("token", this.token);
                  this.loginChanged.emit(true);
                } else {
                  sessionStorage.clear();
                  this.loginChanged.emit(false);
                }
              } else
                this.authnRequest = response.body;
            }
          }
        )
      );
  }

  logout() : Observable<any>{
    this.loginChanged.emit(false);
    return this.http.get("api/auth/logout");
  }

  restore() : Observable<any>{
    return this.http.get("api/auth/restore", {
      headers: {"Accept": "*/*"},
      observe: 'response',
      responseType: 'text'}
    )
    .pipe(
      tap(
        {
          next: (response) => {
              this.token = response.body;
              if (this.token) {
                sessionStorage.setItem("token", this.token);
                this.loginChanged.emit(true);
              } else {
                sessionStorage.clear();
                this.loginChanged.emit(false);
              }
          }
        }
      )
    );
  }

  getToken() : string | null {
    return this.token;
  }

  isAuthenticated() : boolean {
    return this.token != null;
  }

  clearData() {
    this.token = null;
    sessionStorage.clear();
    this.authnRequest = null;
    this.formService.clearData();
  }

  getJwtData() : JwtData | null {
    if (this.token)
      return jwt_decode(this.token);
    return null;
  }

  fakeLogin() {
    return this.http.get("api/auth/login",
      { headers: {"Accept": "*/*"},
        observe: 'response',
        responseType: 'text'}
    )
      .pipe(
        tap(
          {
            next: (response) => {
              this.token = response.body;
              if (this.token) {
                sessionStorage.setItem("token", this.token);
                this.loginChanged.emit(true);
              } else {
                this.loginChanged.emit(false);
                sessionStorage.clear();
              }
            }
          }
        )
      );
  }
}
